import { useNotifications } from "@presentation/components/notifications";

type WorkspaceEntity = "team" | "project";
type WorkspaceAction = "created" | "deleted" | "renamed" | "memberAdded" | "memberRemoved" | "roleChanged";

const ACTION_MESSAGES: Record<WorkspaceAction, (entity: WorkspaceEntity) => string> = {
  created: (entity) => `${entity === "team" ? "Team" : "Project"} created successfully.`,
  deleted: (entity) => `${entity === "team" ? "Team" : "Project"} deleted successfully.`,
  renamed: (entity) => `${entity === "team" ? "Team" : "Project"} renamed successfully.`,
  memberAdded: (entity) => `Member added to the ${entity} successfully.`,
  memberRemoved: (entity) => `Member removed from the ${entity} successfully.`,
  roleChanged: (entity) => `${entity === "team" ? "Team" : "Project"} member role updated successfully.`,
};

export const useWorkspaceSuccessNotification = () => {
  const { pushNotification } = useNotifications();
  return (entity: WorkspaceEntity, action: WorkspaceAction) => pushNotification(ACTION_MESSAGES[action](entity), "success", 5000);
};
